import dataProtection from "../../assets/images/services/data-protection.jpg";
import dataProtectionLaws from "../../assets/images/services/data-protection-laws.jpg";
import dataPrivacy from "../../assets/images/services/business-data-protection.jpg"
const DataPrivacy = () => {
  return (
    <div className="bg-black text-white px-6 md:px-16 py-12 space-y-12 mt-20">
      <section className="space-y-6 max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-4xl font-bold">
          Comprehensive Data Privacy Services
        </h1>
        <h2 className="text-gray-400 text-lg md:text-xl">
          Ensure Global Compliance and Secure Your Data
        </h2>
        <p className="text-gray-300 text-base md:text-lg leading-relaxed max-w-3xl">
          From GDPR to HIPAA and beyond, we help you achieve full compliance
          with international data protection laws.
        </p>
        <img
          src={dataPrivacy}
          alt="Data Privacy"
        />
      </section>

      <hr className="border-gray-700 max-w-4xl mx-auto" />

      <section className="max-w-4xl mx-auto space-y-8 text-gray-300 text-base md:text-lg leading-relaxed">
        <h3 className="text-3xl font-semibold mb-6 text-white">
          Why Data Privacy Matters
        </h3>
        <ul className="list-disc list-inside space-y-4 max-w-3xl mx-auto text-left">
          <li>
            <strong>Mitigates Risk:</strong> Minimize vulnerabilities and
            prevent data breaches.
          </li>
          <li>
            <strong>Builds Trust:</strong> Strengthen customer relationships
            with transparent data practices.
          </li>
          <li>
            <strong>Ensures Compliance:</strong> Meet global privacy law
            requirements with confidence.
          </li>
          <li>
            <strong>Improves Efficiency:</strong> Reduce compliance costs and
            streamline operations.
          </li>
        </ul>
        <img
          src={dataProtection}
          alt="Data Protection"
          className="w-auto max-h-[400px] object-cover rounded-lg shadow-md"
        />
      </section>

      <section className="max-w-4xl mx-auto space-y-8 text-gray-300 text-base md:text-lg leading-relaxed">
        <h3 className="text-3xl font-semibold mb-6 text-white">
          Global Data Protection Regulations We Cover
        </h3>
        <ul className="list-disc list-inside space-y-4 max-w-3xl mx-auto text-left">
          <li>
            <strong>GDPR:</strong> EU data protection with transparency and
            control.
          </li>
          <li>
            <strong>CCPA:</strong> Data rights for California residents.
          </li>
          <li>
            <strong>PDPL:</strong> Saudi Arabia's personal data protection
            framework.
          </li>
          <li>
            <strong>PIPEDA:</strong> Canadian privacy regulation for private
            sector.
          </li>
          <li>
            <strong>HIPAA:</strong> U.S. healthcare data protection standards.
          </li>
          <li>
            <strong>PDPA:</strong> Privacy laws in Singapore and Malaysia.
          </li>
          <li>
            <strong>UK Data Protection Act:</strong> GDPR-complementary
            framework in the UK.
          </li>
          <li>
            <strong>Australia Privacy Act 1988:</strong> Fair handling of data
            in Australia.
          </li>
          <li>
            <strong>APPI (Japan):</strong> Reinforces individual privacy rights
            in Japan.
          </li>
        </ul>
        <img
          src={dataProtectionLaws}
          alt="Data Protection Laws"
          className="w-auto max-h-[500px] object-cover rounded-lg shadow-md"
        />
      </section>

      <section className="max-w-4xl mx-auto space-y-8 text-gray-300 text-base md:text-lg leading-relaxed">
        <h3 className="text-3xl font-semibold mb-6 text-white">
          Our Data Privacy Services
        </h3>
        <div className="space-y-10 text-left max-w-3xl mx-auto">
          <div>
            <h4 className="text-xl font-bold text-white">
              1. Assessments & Audits
            </h4>
            <p>
              Identify compliance gaps and receive detailed recommendations
              through comprehensive audits.
            </p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-white">
              2. Policy Development
            </h4>
            <p>
              Design and implement privacy policies aligned with international
              standards.
            </p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-white">
              3. Employee Training
            </h4>
            <p>
              Train teams to understand data privacy principles and apply best
              practices daily.
            </p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-white">
              4. Risk Management & Incident Response
            </h4>
            <p>
              Mitigate risks and respond effectively to breaches with expert
              support.
            </p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-white">
              5. Continuous Monitoring
            </h4>
            <p>
              Keep pace with regulatory changes and evolving threats with
              ongoing privacy evaluations.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto space-y-8 text-gray-300 text-base md:text-lg leading-relaxed">
        <h3 className="text-3xl font-semibold mb-6 text-white">
          Industries We Serve
        </h3>
        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto text-left">
          <ul className="space-y-4">
            <li>
              <strong>Financial Services:</strong> Comply with strict privacy
              standards.
            </li>
            <li>
              <strong>Healthcare:</strong> Protect patient data and adhere to
              HIPAA.
            </li>
            <li>
              <strong>Retail & E-commerce:</strong> Earn consumer trust through
              transparency.
            </li>
          </ul>
          <ul className="space-y-4">
            <li>
              <strong>Technology:</strong> Safeguard user and proprietary data.
            </li>
            <li>
              <strong>Government:</strong> Manage public data responsibly and
              lawfully.
            </li>
          </ul>
        </div>
      </section>

      <section className="max-w-4xl mx-auto space-y-8 text-gray-300 text-base md:text-lg leading-relaxed">
        <h3 className="text-3xl font-semibold mb-6 text-white">
          Why Choose Us?
        </h3>
        <ul className="list-disc list-inside space-y-4 max-w-3xl mx-auto text-left">
          <li>
            <strong>Enhance Data Security:</strong> Robust protection for
            sensitive data.
          </li>
          <li>
            <strong>Simplify Compliance:</strong> Navigate complex regulations
            with ease.
          </li>
          <li>
            <strong>Boost Confidence:</strong> Show your commitment to data
            protection.
          </li>
        </ul>
      </section>

      <section className="max-w-4xl mx-auto">
        <h3 className="text-3xl font-semibold mb-4 text-white">
          Secure Your Data, Secure Your Future
        </h3>
        <p className="text-gray-300 text-base md:text-lg mb-6 max-w-3xl mx-auto leading-relaxed">
          Investing in data privacy is not just regulatory—it’s strategic. Let
          our experts help you protect your future.
        </p>
        <p className="text-gray-300 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
          Contact us today to ensure full compliance and peace of mind.
        </p>
      </section>
    </div>
  );
};

export default DataPrivacy;
